import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

/* 에디터 */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';

export default function MeetingModify() {
  const navigate = useNavigate();

  return (
    <MeetWrap>
      <div className='content-inner '>
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Minute Of Meeting</h4>
          </div>
        </div>
        <div className='content noArea'>
          <form>
            <div className='form-head'>
              <input type='text' name='subject' id='subject' placeholder='Please enter a title'/>
            </div>

            <CKEditor editor={ClassicEditor}/>

            <div className='edit-btn'>
              <button className='submit'>Modify</button>
              <button className='list' onClick={() => navigate('/client/meeting/list')}>List</button>
            </div>
          </form>
        </div>
      </div>
    </MeetWrap>
  )
}

const MeetWrap = styled.div`
  position: relative;
  flex: 1;

  .form-head {
    margin-bottom: 30px;
    position: relative;

    input {
      width: 100%;
      height: 45px;
      line-height: 45px;
      padding: 0 16px;
      font-weight: 400;
      font-size: 18px;
      color: #000000;

      &::placeholder {
        font-weight: 400;
        font-size: 16px;
        color: #111111;
      }
    }
  }

  .ck .ck-content {
    height: 420px;
  }

  .btn-list {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      display: block;
      width: 125px;
      height: 45px;
      line-height: 45px;
      background: #0072B9;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      border-radius: 10px;
    }
  }
`;